'use client';

import { ServerActionName } from '@headless-workspace/config';
import { CONTENT_ASSET_KEYS, ResultEmpty, ResultFailure, ResultSuccess } from '@headless-workspace/core-domain';
import { getContentAssetServerAction } from '../../../server';
import { useSafeSWR } from '../hooks';
import { UserRevalidationKey } from '../user';
import { getCachedContentAsset } from './cache';

export const useDTSLegalMentionsAssets = () => {
    const contentAsset = getCachedContentAsset(CONTENT_ASSET_KEYS.DTS_LEGAL_MENTIONS);

    const { data, isLoading, error } = useSafeSWR(
        contentAsset ? null : `${UserRevalidationKey.ContentAsset}-${CONTENT_ASSET_KEYS.DTS_LEGAL_MENTIONS}`,
        ServerActionName.getContentAssetServerAction,
        () => getContentAssetServerAction([CONTENT_ASSET_KEYS.DTS_LEGAL_MENTIONS]),
    );

    if (contentAsset) {
        return {
            isLoading: false,
            result: ResultSuccess(contentAsset),
        };
    }

    if (!data) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure('error', error instanceof Error ? error.message : ''),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    if (data.type === 'empty' || data.data.length === 0) {
        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: ResultSuccess(data.data[0]) };
};
